import sparql from "refractor/sparql";
export default sparql;